<template>
  <div>
    <v-data-table
      :headers="installationPositionDataTableHeaders"
      :items="installationPositionItems"
      class="elevation-1 my-5 mx-5"
      :search="searchInstallationPositionItems"
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :header-props="headerProps"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>安裝位置清單</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="searchInstallationPositionItems"
            append-icon="mdi-magnify"
            :label="$t('quotation_item_new_install_search')"
            single-line
            hide-details
            clearable
          ></v-text-field>
        </v-toolbar>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { HttpInstallPosition } from '@/js/http-Manager'
export default {
  props: {
    tab: {
      type: String
    }
  },
  name: 'InstallPositionDataTable',
  data: () => ({
    installationPositionItems: [],
    searchInstallationPositionItems: ''
  }),
  async mounted () {
    await this.getInstallPositionList()
  },
  watch: {
    async tab (val) {
      if (val === 'tab-1') {
        await this.getInstallPositionList()
      }
    }
  },
  computed: {
    installationPositionDataTableHeaders () {
      return [
        { text: '序號', align: 'start', value: 'Type' },
        { text: '安裝位置', align: 'start', value: 'Name' },
        { text: '定義', align: 'start', value: 'Description' }
      ]
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    }
  },
  methods: {
    async getInstallPositionList () {
      let response = await HttpInstallPosition.GetAllInstallPosition()
      this.installationPositionItems = response.status === 200 ? response.data.Data : []
    }
  }
}
</script>
